import { StateType } from 'data/types'

import { PaymentMethodType } from '../types'

const getData = (state: StateType, currency: string, paymentMethod?: PaymentMethodType) => {
  const pm = paymentMethod ?? 'ALL'
  const pmState = state.payments.withdrawFeesAndMin[pm]
  if (pmState === undefined) return undefined
  const pmData = pmState.data
  if (pmData === undefined) return undefined
  return pmData[currency]
}

export const getFee = (state: StateType, currency: string, paymentMethod?: PaymentMethodType) =>
  getData(state, currency, paymentMethod)?.fee

export const getMin = (state: StateType, currency: string, paymentMethod?: PaymentMethodType) =>
  getData(state, currency, paymentMethod)?.min
